import React, { useState, useEffect } from 'react';
import './DisclaimerModal.css';

const DisclaimerModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Check if user has already agreed in this session
        // Using sessionStorage so it shows up again if they close the browser tab and come back
        const hasAgreed = sessionStorage.getItem('hasAgreedToDisclaimer');

        if (!hasAgreed) {
            setIsOpen(true);
            // Disable scrolling on body when modal is open
            document.body.style.overflow = 'hidden';
        }
    }, []);

    const handleAgree = () => {
        sessionStorage.setItem('hasAgreedToDisclaimer', 'true');
        setIsOpen(false);
        // Re-enable scrolling
        document.body.style.overflow = 'unset';
    };

    if (!isOpen) return null;

    return (
        <div className="disclaimer-overlay" role="dialog" aria-modal="true" aria-labelledby="disclaimer-title">
            <div className="disclaimer-content">
                <h2 id="disclaimer-title" className="disclaimer-title">Disclaimer & Confirmation</h2>

                <div className="disclaimer-text">
                    <p>
                        As per the rules of the Bar Council of India, lawyers and law firms are not permitted to solicit work and advertise.
                        By clicking on the "I AGREE" button below, you acknowledge and confirm the following:
                    </p>

                    <ul>
                        <li>There has been no advertisement, personal communication, solicitation, invitation or inducement of any sort whatsoever from us or any of our members to solicit any work through this website;</li>
                        <li>You wish to gain more information about us for your own information and use;</li>
                        <li>The information about us is provided to you only on your specific request and any information obtained or materials downloaded from this website is completely at your own volition and any transmission, receipt or use of this site would not create any lawyer-client relationship.</li>
                    </ul>

                    <p>
                        The information provided under this website is solely available at your request for informational purposes only and should not be interpreted as soliciting or advertisement. We are not liable for any consequence of any action taken by you relying on material / information provided under this website. In cases where you have any legal issues, you must seek independent legal advice.
                    </p>
                </div>

                <div className="disclaimer-actions">
                    <button className="btn btn-primary" onClick={handleAgree}>
                        I AGREE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerModal;
